module.exports = __webpack_public_path__ + "static/fipclovebearmain-ff71eed2375bfc089be10e9d58c765e0.jpeg";